module.exports = __webpack_public_path__ + "media/images/review_form_star_full-a433d044462361feb2560f2120444b9b.svg";